/*
 * @Author: vicshang
 * @Date: 2020-08-17 14:23:50
 * @Last Modified by: vicshang
 * @Last Modified time: 2020-08-17 14:23:55
 */
import CustomCard from './custom-card.vue';
export default CustomCard;
